import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Guenzburg() {
  return (
    <ServiceLayout
      title="Umzugsunternehmen in Günzburg"
      description="Ihr starker Partner für Umzüge und Handwerksleistungen in Günzburg. Pünktlich, sicher und professionell."
      image="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df931da73c728e8789a3.jpg"
      heroBg="https://vibe.filesafe.space/1781514922662573702/assets/85db79d9-8fa9-4428-987d-307a79f50c14.png"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Ihr Umzug in Günzburg
          </h2>
          <p className="text-lg text-neutral-600">
            Sie planen einen Umzug in Günzburg oder in die Umgebung? Wir unterstützen Sie mit Muskelkraft, Know-how und dem passenden Equipment. Unser Team sorgt dafür, dass Ihr Hab und Gut sicher und unbeschadet im neuen Zuhause ankommt.
          </p>
          <p className="text-lg text-neutral-600">
            Zusätzlich zum reinen Transport bieten wir Ihnen umfangreiche Handwerksleistungen wie Möbelmontage, Elektro- und Lichtinstallation an, damit Sie sich in Ihrem neuen Heim sofort wohlfühlen können.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Rundum-Sorglos-Umzugsservice",
              "Zusätzliche Handwerksleistungen buchbar",
              "Termingerechte Ausführung",
              "Kostenloses und unverbindliches Angebot"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr zuverlässiges Umzugsunternehmen in Günzburg</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Umzug bringt oft viele Herausforderungen mit sich – vom Verpacken des Hausrats bis hin zur sicheren Beförderung sperriger Möbelstücke. Als Ihr Umzugsunternehmen für Günzburg und Umgebung nehmen wir Ihnen diese Last von den Schultern. Mit jahrelanger Erfahrung und einem engagierten Team sorgen wir dafür, dass Ihr Wohnungswechsel oder Firmenumzug reibungslos, sicher und vor allem stressfrei abläuft.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Die Große Kreisstadt Günzburg mit ihrer charmanten Altstadt und den umliegenden ländlichen Gemeinden erfordert oft eine individuelle Umzugsplanung. Egal ob Sie aus einer engen Altstadtwohnung ausziehen oder in ein neues Einfamilienhaus in der Region ziehen – wir verfügen über die passenden Fahrzeuge und das logistische Know-how, um jeden Umzug effizient zu meistern. Wir kümmern uns um alles, damit Sie sich entspannt auf Ihr neues Zuhause freuen können.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge in Günzburg</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Jeder Privatumzug ist einzigartig. Wir bieten Ihnen maßgeschneiderte Umzugslösungen – von der Bereitstellung von Umzugskartons über den sicheren Transport bis hin zum Full-Service-Umzug, bei dem wir Ihnen sogar das Ein- und Auspacken abnehmen.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Gewerbliche Umzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Für Unternehmen in Günzburg bieten wir professionelle Firmenumzüge an. Wir planen den Standortwechsel so, dass Ihr Geschäftsbetrieb so wenig wie möglich gestört wird. IT-Anlagen, Akten und Büromöbel werden sicher und diskret transportiert.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Umfassende Handwerksleistungen für Ihren Neustart</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Umzug besteht nicht nur aus dem Tragen von Kisten. Oft müssen Möbel abgebaut, Lampen demontiert und Küchen angepasst werden. Unser Service in Günzburg geht weit über den reinen Transport hinaus. Unsere erfahrenen Handwerker übernehmen die fachgerechte Demontage und Montage Ihrer Möbel, egal ob es sich um einfache Regale oder komplexe Schrankwände handelt.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Zudem bieten wir professionelle Elektro- und Lichtinstallationen an. Wir schließen Ihre Waschmaschine an, montieren Deckenleuchten und sorgen dafür, dass in Ihrem neuen Zuhause alles sicher funktioniert. Auch Bodenbelags- und Pflasterarbeiten gehören zu unserem Portfolio – so erhalten Sie alle wichtigen Leistungen rund um Ihren Umzug aus einer Hand.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">Festpreisgarantie und voller Versicherungsschutz</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Umziehen in Günzburg muss nicht teuer sein, aber die Kosten sollten von Anfang an transparent sein. Wir besichtigen Ihr Umzugsgut kostenlos vor Ort und erstellen Ihnen ein faires Festpreisangebot. Keine versteckten Kosten, keine Nachverhandlungen. Zudem ist Ihr Hab und Gut während des gesamten Umzugsprozesses über unsere Betriebshaftpflicht- und Transportversicherung vollumfänglich abgesichert.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Gründe für Easy Umzug in Günzburg</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Stressfreier Ablauf</h3>
                    <p className="text-neutral-400">Wir übernehmen die komplette Organisation und Durchführung, damit Sie sich auf wichtigere Dinge konzentrieren können.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Erfahrenes Personal</h3>
                    <p className="text-neutral-400">Unser Team ist bestens geschult im Umgang mit empfindlichem Mobiliar und schwerem Transportgut.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Transparente Preise</h3>
                    <p className="text-neutral-400">Mit unserer Festpreisgarantie erleben Sie nach dem Umzug keine bösen Überraschungen auf der Rechnung.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
